module.exports = __webpack_public_path__ + "files/81dc39b42da159ad95bdc28150d16582.svg";